import { SIZES_JSON } from "@eventbrite/valkyrie-eds-iconography";
import PropTypes from "prop-types";

export const SIZES = Object.keys(SIZES_JSON).map((size) =>
  size.replace("icon-", ""),
);

export const VECTOR_IMAGE_ICON = "icon";
export const VECTOR_IMAGE_BRAND = "brand";
export const VECTOR_IMAGE_PAYMENT = "payment";
export const VECTOR_IMAGE_GRAPHIC = "graphic";
export const VECTOR_IMAGE_ILLUSTRATION = "illustration";

const RESET_TYPES = [VECTOR_IMAGE_BRAND, VECTOR_IMAGE_ILLUSTRATION] as const;

export const SHOULD_USE_RESET_PATTERN = new RegExp(
  `(${RESET_TYPES.join("|")})$`,
);

export const SVG_PROP_TYPE = PropTypes.node;
